import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { DatePipe } from '@angular/common';
import { ScreeningPartyService } from 'src/app/core/services/screening-parties/screening-party.service';
import { partitionArray } from '@angular/compiler/src/util';
import { AttachSession } from 'protractor/built/driverProviders';
import { MatIconRegistry } from '@angular/material/icon';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-join-parties',
  templateUrl: './join-parties.component.html',
  styleUrls: ['./join-parties.component.css'],
})
export class JoinPartiesComponent implements OnInit {
  parties: any[] = [];
  FirstName: any = '';
  sortByDate: string;
  sortByName: string;
  searchBox: any = '';
  filterPartyList: any[];
  reverse = false;
  sorted = false;
  rev = false;
  screeningObject: any;
  eventId: any;
  rsvpbtn = false;
  popup: boolean;
  display = '';
  timezone:any;

  constructor(
    private spotlightService: SpotlightService,
    private screeningPartyService: ScreeningPartyService,
    private router: Router,
    public datepipe: DatePipe,
    private matIconRegistry: MatIconRegistry,
  ) {}

  ngOnInit(): void {
    this.getpartylist();
    this.filterPartyList = this.parties;
    this.joinTime();
    var zone = moment.tz.guess();       
    this.timezone = moment.tz(zone).format("z");
  }


    //Following function returns user's current timezone name for Screening Party
    userTimezoneNameSP(date:any){
   
      var zone = moment.tz.guess();   
      var newDate = new Date(date).toString()    
      var timezoneName = moment(newDate).tz(zone).format('z')
      return timezoneName;
    }

  search(): void {
    if (this.searchBox.length) {
      this.filterPartyList = this.getListings(this.searchBox);
    } else {
      this.filterPartyList = this.parties;
    }
  }

  editParty(party: any): void {
    this.screeningPartyService.setScreeningParty(party);
    this.screeningPartyService.setScreeningPartyId(party.id);
    this.screeningPartyService.setIsUpdate(true);
    this.router.navigate(['/cinejoy/screening-parties/getting-started']);
  }

  sortbydate(): void {
    this.sortByDate = 'meetingDateTime';
    this.sorted = true;
    this.reverse = !this.reverse;
    this.sortByName = '';
  }

  sortbyname(): void {
    this.sortByName = 'movieName';
    this.sorted = true;
    this.rev = !this.rev;
    this.sortByDate = '';
  }

  getpartylist(): void {
    this.screeningPartyService.getPartiesList().subscribe(
      (res) => {
        console.log(res);
        if (res) {
          this.parties = res;

          this.filterPartyList = this.parties;

          this.filterPartyList.forEach((party) => {
            const enableJoinButton =
              (new Date(party.meetingDateTime).valueOf() -
                new Date().valueOf()) /
                60000 <
                10 && party.isUserRegistered;
            party.enableJoinButton = enableJoinButton;
            party.rsvpbtn = false;
            party.isReadMore = false;
           
            party.capacityFull =
              party.registeredUsers >= party.meetingCapacity * 1.3 &&
              !party.isUserRegistered;
          });
        }
      },

      (error) => {
        console.log(error);
      }
    );
  }
  

  onRsvp(id: any): void {
    this.screeningPartyService.postRsvp(id).subscribe(
      (res) => {
        console.log('rsvp');
        console.log(res);

        this.changeRegisterStatus(id, true);
      },

      (error) => {
        console.log(error);
      }
    );
  }
  changeRegisterStatus(id, success): void {
    this.filterPartyList.filter((party) => {
      if (party.id === id && success) {
        party.isUserRegistered = true;
      } else {
        party.showPartyFullMessage = true;
        console.log('User Already Registered');
      }
    });
  }

  getListings(searchText: any): any {
    return this.parties.filter((item) => item.movieName.includes(searchText));
  }
  gotoMoviePage(eventId): any {
    console.log(eventId);
  }
  gotoJoin(meetingLink): void {
    window.open(meetingLink, '_blank');
  }

  readMoreOrLess(id: any, value: boolean) {
    console.log(id);
    this.filterPartyList.forEach((ele) => {
      if (ele.id == id) {
        ele.isReadMore = value;
      }
    });
  }
joinTime() {
      setInterval(() => {
        
        this.filterPartyList.forEach((party) => {
           if(!party.enableJoinButton){
            const enableJoinButton =
            (new Date(party.meetingDateTime).valueOf() -
              new Date().valueOf()) /
              60000 <
              10 && party.isUserRegistered;
              party.enableJoinButton = enableJoinButton;}
           }, 60000);
})}

navigateShowcase(event){
  console.log(event);
  let name = event.movieName.replace(/ /g, '-');
  this.router.navigateByUrl(`/cinejoy/showcase/moviepage/${event.cinejoyFeaturedMovie}/${name}`)
}

}
